import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';

export default function SelectOption({ className, children, value, disabled }) {
  return (
    <option className={cn('cp-select-option', className)} value={value} disabled={disabled}>
      {children}
    </option>
  );
}

SelectOption.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
};
